import React from "react";

import { Button } from "./ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "./ui/dialog";

interface Props {
  open: boolean;
  onClose: () => void;
  onClick: () => void;
  title: string;
  description: string;
  closeButton: string;
  continueButton: string;
}

export default function Modal({
  open,
  onClose,
  onClick,
  title,
  description,
  closeButton,
  continueButton,
}: Props) {
  return (
    <Dialog open={open} onOpenChange={(state) => (!state ? onClose() : null)}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="ghost" onClick={onClose} type="button">
            {closeButton}
          </Button>
          <Button onClick={onClick} type="button">
            {continueButton}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
